import React, { useState, useEffect, useCallback } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import TaskModalWrapper from './TaskModal.styles';
import { Form, Input, Button, Select, Row, Col, DatePicker } from 'antd';
import _ from 'lodash';
import { taskPriorities } from '@iso/constants/taskPriorities';
import { taskStatus } from '@iso/constants/taskStatus';
import Loader from '@iso/components/utility/loader';
import { propertyService, taskService } from '@iso/services';
import { dateHelper } from '@iso/lib/helpers/dateHelper';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import modalActions from '@iso/redux/modal/actions';
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'

const { Option } = Select;
const { closeModal } = modalActions;

const TaskModal = (props) => {
  const activePermission = useSelector((state) => state.permission.activePermission);
  const activePropertyId = useSelector((state) => state.property.activePropertyId);
  
  const [form] = Form.useForm();
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [modalLoading, setModalLoading] = useState(true);
  const [assignees, setAssignees] = useState([]);
  const modalVisibility = useSelector((state) => state.modal.modalVisibility);
  const modalData = useSelector((state) => state.modal.modalData);
  const dispatch = useDispatch();
  const [dataTask, setDataTask] = useState({});

  const updateDataAssignee = useCallback(() => {
    propertyService.getListUsersOfProperty(props.propertyId).then(res => {
      if(res.code === '0000'){
        setAssignees(res.users);
        setModalLoading(false);
      }
    });
  }, [props]);
  useEffect(() => {   
        setFields([
          {
            name: ['task', 'priority'],
            value: 'medium',
          },
          {
            name: ['task', 'status'],
            value: 'todo',
          },
          {
            name: ['task', 'assignee_id'],
            value: 0,
          },
          {
            name: ['task', 'primary_object_id'],
            value: props.dataObject ? props.dataObject.id : 0,
          },
        ]);
      if(props.propertyId && modalVisibility){
        updateDataAssignee();
      
    }
  }, [props.propertyId, updateDataAssignee, props.visibleTaskModal]);

  const cancelModal = () => {
    // dispatch(closeModal());
    // setTags([]);
    // if(modalData.layer){
    //   modalData.featureGroup.leafletElement.removeLayer(modalData.layer);
    // }
    props.cancelTaskModal();
    setLoading(false);
    form.resetFields();
  }

  const renderOptionPriority = () => {
    let options = [];
    _.forEach(taskPriorities, (taskPriority, index) => {
      options.push(
        <Option key={index} value={taskPriority.value}>
          {taskPriority.label}
        </Option>
      );
    })
    return (
      <Select
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionStatus = () => {
    let options = [];
    _.forEach(taskStatus, (status, index) => {
      options.push(
        <Option key={index} value={status.value}>
          {status.label}
        </Option>
      );
    })
    return (
      <Select
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const renderOptionAssignee = (users) => {
    let options = [];
    _.forEach(users, (user, index) => {
      options.push(
        <Option key={user.id} value={user.id}>
          {user.name} | {user.email} 
        </Option>
      );
    })
    return (
      <Select
        allowClear
        size="large"
      >
        <Option key={0} value={0}>
          Not assigned
        </Option>
        {options}
      </Select>
    );
  }

  const renderOptionObject = (objects) => {
    let options = [];
    _.forEach(objects, (object, index) => {
      options.push(
        <Option key={object.id} value={object.id}>
          {object.name}
        </Option>
      );
    })
    return (
      <Select
        allowClear
        size="large"
        disabled={JSON.stringify(props.dataObject) !== '{}' ? true : false}
      >
        <Option key={0} value={0}>
          No paddock
        </Option>
        {options}
      </Select>
    );
  }

  const handleSubmit = (e) => {
    setLoading(true);

    form
      .validateFields()
      .then(values => {
        values.task.tags = tags;
        onStore(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
        setLoading(false);
      });
  }

  const onStore = (values) => {
    const data = {
      task:{
        ...values.task,
        due_date: values.task.due_date ? dateHelper.dateForAPI(values.task.due_date) : '',
        point: dataTask.point,
        property_id: props.propertyId
      }
    }

    taskService.storeOrUpdateTasks(data, dataTask.id).then(res => {
      if(res.code === '0000'){
        props.onSaved(res.task);
        props.updatePropertyDetail(props.propertyId);
        cancelModal();
        form.resetFields();
        setTags([]);
      } else {
        setLoading(false);
      }
    });
  }

  const editLocation = () => {
    props.editLocation();
    cancelModal();
  }

  const handleChangeTag = (input_tags) => {
    setTags(input_tags);
  }

  useEffect(() => {
    handleChangeTag(tags)
  }, [tags]);
  return (
    <TaskModalWrapper
      className="user-access-modal"
      forceRender={true}
      visible={ props.visibleTaskModal}
      title={ dataTask.id ? <IntlMessages id="propertyMapPage.editTask" /> : <IntlMessages id="propertyMapPage.addTask" /> }
      onCancel={cancelModal}
      maskClosable={false}
      footer={[
        (activePermission == "owner" || activePermission == "admin"|| activePermission == "modify") && dataTask.id && <Button key="editLocation" onClick={editLocation} style={{float: 'left'}} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.move" />}
        </Button>,
        <Button key="back" onClick={cancelModal} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        (activePermission == "owner" || activePermission == "admin"|| activePermission == "modify") && <Button key="submit" className="btn-success" type="primary" onClick={handleSubmit} loading={loading}>
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>,
      ]}
    >
      {
       
        <Form
          form={form}
          name="addEditTask"
          layout="vertical"
          scrollToFirstError
          fields={fields}
        >
          <div className="form-body">
            <Form.Item
              name={['task', 'title']}
              className="isoInputWrapper"
              label="Title"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
                {
                  whitespace:true,
                  message: 'Please input your Title',
                },
              ]}
            >
              <Input size="large" placeholder="Input task title"/>
            </Form.Item>
            <Form.Item
              name={['task', 'priority']}
              label="Priority"
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              {renderOptionPriority()}
            </Form.Item>
            <Row>
              <Col xs={{span: 24}} md={{span: 11}}>
                <Form.Item
                  name={['task', 'due_date']}
                  className="isoInputWrapper"
                  label="Due Date"
                >
                  <DatePicker size="large"/>
                </Form.Item>
              </Col>
              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                <Form.Item
                  name={['task', 'status']}
                  className="isoInputWrapper"
                  label="Status"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                  {renderOptionStatus()}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={{span: 24}} md={{span: dataTask.id || JSON.stringify(props.dataObject) !== '{}' ? 11 : 24}}>
                <Form.Item
                  name={['task', 'assignee_id']}
                  className="isoInputWrapper"
                  label="Assignee"
                >
                  {renderOptionAssignee(assignees)}
                </Form.Item>
              </Col>
              {
                (dataTask.id || JSON.stringify(props.dataObject) !== '{}') &&
                <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                  <Form.Item
                    name={['task', 'primary_object_id']}
                    className="isoInputWrapper"
                    label="Object"
                  >
                    {renderOptionObject(props.primaryObjects)}
                  </Form.Item>
                </Col>
              }
            </Row>
            <Form.Item
              className="isoInputWrapper"
              label="Tags"
            >
              <TagsInput name={['task', 'tags']} value={tags} onChange={handleChangeTag} addOnBlur="true"/>
            </Form.Item>
            <Form.Item name={['task', 'details']} label="Details">
              <Input.TextArea />
            </Form.Item>
          </div>
        </Form>
      }
    </TaskModalWrapper>
  );
}

export default TaskModal;